// LuxuryPage.jsx
import React from "react";
// import "./LuxuryPage.css";
import "../App.css";
import { useEnquiryModal } from "./EnquiryModal";
import { FaLocationDot } from "react-icons/fa6";
import { ENQUIRY_CTA } from "../constants";

const LuxuryPage = () => {
  const { openModal } = useEnquiryModal();
  return (
    <div id="about" className="luxury-page">
      {/* ----------- Section 1: Luxury Launch ----------- */}
      <section className="luxury-section">
        <div className="luxury-image">
          <img
            src="Assets/banner2.png"
            alt="Luxury View"
          />
        </div>
        <div className="luxury-text">
          <h2 className="font-semibold">
            Aldar Greenwoods
          </h2>
          <div className="luxury-location flex items-center">
            <FaLocationDot className="text-[#997736] mr-2" />
            <span className="text-[#997736] font-bold text-lg">Silicon Oasis Dubai</span>
          </div>
          <p>
            Discover Greenwoods by Aldar, a thoughtfully planned residential community in Dubai Silicon Oasis, offering a harmonious blend of contemporary living, lush green landscapes, and family-friendly surroundings. Featuring a selection of villas & townhouses, the community is designed to offer spacious homes, peaceful outdoor spaces, and a lifestyle focused on comfort and connectivity.With landscaped parks, walking paths, and convenient access to major road networks, Greenwoods offers an attractive opportunity for both homebuyers and property investors. Its location in Dubai Silicon Oasis, along the planned Dubai Metro Blue Line route, adds to its long-term appeal. 
          </p>
          <button onClick={() => openModal(ENQUIRY_CTA.INTRO)} className="mt-4 font-semibold border-2 rounded-md border-[#997736] text-[#997736] hover:text-white px-6 py-2 hover:bg-[#997736] transition">DOWNLOAD BROCHURE</button>
        </div>
      </section>
    </div>
  );
};

export default LuxuryPage;
